// src/constants/listingConstants.js
export const STATUS = {
  TO_PRINT: "To Print",
  LABEL_PRINTED: "Label Printed",
  PHOTO_UPLOADED: "Photo Uploaded",
  READY_TO_LIST: "Draft Ready",
  LISTED: "Listed",
};

export const TABS = {
  TO_PRINT: "To Print",
  PHOTO_ING: "Photo'ing",
  READY: "Ready to List",
  LIVE: "Live",
  ALL: "All",
};

export const CONDITION_OPTIONS = [
  "Near Mint",
  "Lightly Played",
  "Moderately Played",
  "Heavily Played",
  "Damaged",
];

export function formatDateTime(raw) {
  if (!raw) return "";
  const date = new Date(raw);
  const day = String(date.getDate()).padStart(2, "0");
  const month = date.toLocaleString("en-AU", { month: "long" });
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  return `${day}-${month}-${year} ${hours}:${minutes}`;
}
